"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    r = require("mobx"),
    n = require("react"),
    t = (e = n) && "object" == typeof e && "default" in e ? e.default : e;

if (!n.useState) throw new Error("mobx-react-lite requires React with Hooks support");
if (!r.spy) throw new Error("mobx-react-lite requires mobx at least version 4 to be available");
var o = !1;

function u() {
  return o;
}

function i() {
  return (i = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];

      for (var t in n) {
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function c() {
  var e = n.useState(0)[1];
  return n.useCallback(function () {
    e(function (e) {
      return e + 1;
    });
  }, []);
}

function a(e) {
  return "function" == typeof Symbol ? Symbol.for(e) : "__$mobx-react " + e + "__";
}

var f = {};

function s() {
  return "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : f;
}

var p = a("observerBatching");

function d(e) {
  return r.getDependencyTree(e);
}

var l,
    v = new Set();

function b() {
  void 0 === l && (l = setTimeout(y, 1e4));
}

function y() {
  l = void 0;
  var e = Date.now();
  v.forEach(function (r) {
    var n = r.current;
    n && e >= n.cleanAt && (n.reaction.dispose(), r.current = null, v.delete(r));
  }), v.size > 0 && b();
}

var h = !1,
    w = [];

function O(e) {
  return function () {
    h ? w.push(e) : e();
  };
}

function m(e) {
  h = !0, w = [];

  try {
    var r = e();
    h = !1;
    var n = w.length > 0 ? w : void 0;
    return t.useLayoutEffect(function () {
      n && n.forEach(function (e) {
        return e();
      });
    }, [n]), r;
  } finally {
    h = !1;
  }
}

var x = {};

function g(e) {
  return "observer" + e;
}

function S(e, n, o) {
  if (void 0 === n && (n = "observed"), void 0 === o && (o = x), u()) return e();
  var i = O((o.useForceUpdate || c)()),
      a = t.useRef(null);

  if (!a.current) {
    var f = new r.Reaction(g(n), function () {
      s.mounted ? i() : (f.dispose(), a.current = null);
    }),
        s = function (e) {
      return {
        cleanAt: Date.now() + 1e4,
        reaction: e
      };
    }(f);

    a.current = s, v.add(a), b();
  }

  var p = a.current.reaction;
  return t.useDebugValue(p, d), t.useEffect(function () {
    return v.delete(a), a.current ? a.current.mounted = !0 : (a.current = {
      reaction: new r.Reaction(g(n), function () {
        i();
      }),
      cleanAt: Infinity
    }, i()), function () {
      a.current.reaction.dispose(), a.current = null;
    };
  }, []), m(function () {
    var r, n;
    if (p.track(function () {
      try {
        r = e();
      } catch (e) {
        n = e;
      }
    }), n) throw n;
    return r;
  });
}

var j = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0
};

function E(e) {
  var r = e.children || e.render;
  return "function" != typeof r ? null : S(r);
}

function R(e, r, n, t, o) {
  var u = "function" == typeof e[r],
      i = "function" == typeof e["children" === r ? "render" : "children"];
  return u && i ? new Error("MobX Observer: Do not use children and render in the same time in`" + n) : u || i ? null : new Error("Invalid prop `" + o + "` of type `" + typeof e[r] + "` supplied to `" + n + "`, expected `function`.");
}

function A(e, n) {
  if (!n || void 0 !== e) {
    var o = t.useState(function () {
      return r.observable(e, {}, {
        deep: !1
      });
    })[0];
    return r.runInAction(function () {
      Object.assign(o, e);
    }), o;
  }
}

E.propTypes = {
  children: R,
  render: R
}, E.displayName = "Observer", exports.Observer = E, exports.isObserverBatched = function () {
  return s()[p];
}, exports.isUsingStaticRendering = u, exports.observer = function (e, r) {
  if (u()) return e;

  var t,
      o,
      c,
      a = i({
    forwardRef: !1
  }, r),
      f = e.displayName || e.name,
      s = function s(r, n) {
    return S(function () {
      return e(r, n);
    }, f);
  };

  return s.displayName = f, t = n.memo(a.forwardRef ? n.forwardRef(s) : s), o = e, c = t, Object.keys(o).forEach(function (e) {
    j[e] || Object.defineProperty(c, e, Object.getOwnPropertyDescriptor(o, e));
  }), t.displayName = f, t;
}, exports.observerBatching = function (e) {
  "function" == typeof e && r.configure({
    reactionScheduler: e
  }), s()[p] = !0;
}, exports.observerBatchingOptOut = function () {
  r.configure({
    reactionScheduler: void 0
  }), s()[p] = !0;
}, exports.useAsObservableSource = function (e) {
  return A(e, !1);
}, exports.useForceUpdate = c, exports.useLocalStore = function (e, n) {
  var o = A(n, !0);
  return t.useState(function () {
    var n = r.observable(e(o));
    return function (e) {
      if (!e || "object" != typeof e) return !1;
      var r = Object.getPrototypeOf(e);
      return !r || r === Object.prototype;
    }(n) && r.runInAction(function () {
      Object.keys(n).forEach(function (e) {
        var t,
            o,
            u = n[e];
        "function" == typeof u && (n[e] = (t = u, o = n, function () {
          for (var e = arguments.length, n = new Array(e), u = 0; u < e; u++) {
            n[u] = arguments[u];
          }

          return r.transaction(function () {
            return t.apply(o, n);
          });
        }));
      });
    }), n;
  })[0];
}, exports.useObserver = S, exports.useQueuedForceUpdate = O, exports.useQueuedForceUpdateBlock = m, exports.useStaticRendering = function (e) {
  o = e;
};